import Default from './svg/registrauto-default.svg'
import Light from './svg/registrauto-light.svg'
import DefaultSM from './svg/registrauto-r-default.svg'
import LightSM from './svg/registrauto-r-light.svg'

const LogosTypes = {
    default: Default,
    light: Light,
    'default-sm': DefaultSM,
    'light-sm': LightSM
}

export default LogosTypes

export type LogoName = 'default' | 'light' | 'default-sm' | 'light-sm'
